<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        md="6"
        sm="9"
      >
        <v-slide-y-transition appear>
          <base-material-card
            color="success"
            light
            max-width="100%"
            min-width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  Demo upload PDF for Branding
                </h1>
              </div>
            </template>

            <v-card-text class="text-center">
              <div>
                <v-form
                  v-model="valid"
                  refs="form"
                >
                  <h1 class="pt-6">
                    Step 1: Select Header
                  </h1>
                  <v-row justify="center">
                    <v-radio-group
                      v-model="header"
                      row
                      mandatory
                      class="ml-0 pt-6"
                    >
                      <v-radio
                        label="McAlpine Free Limited"
                        color="success"
                        value="mcalpinefree_letterhead"
                      />

                      <v-radio
                        label="Law Enforcement"
                        color="success"
                        value="law_enforcement_letterhead"
                      />
                      <v-radio
                        label="Government"
                        color="success"
                        value="government_letterhead"
                      />
                    </v-radio-group>
                  </v-row>
                  <h1 class="pt-6 pb-6">
                    Step 2: Upload PDF
                  </h1>
                  <v-file-input
                    v-model="file"
                    class="pt-6"
                    color="success"
                    counter
                    label="PDF Input"
                    placeholder="Select your PDF"
                    prepend-icon="mdi-paperclip"
                    outlined
                    accept=".pdf"
                    show-size
                    :rules="fileRules"
                    error-count="5"
                    :display-size="1000"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        v-if="index < 2"
                        color="success"
                        dark
                        label
                        small
                      >
                        {{ text }}
                      </v-chip>

                      <span
                        v-else-if="index === 2"
                        class="overline grey--text text--darken-3 mx-2"
                      >
                        +{{ files.length - 2 }} File(s)
                      </span>
                    </template>
                  </v-file-input>
                  <v-btn
                    large
                    color=""
                    depressed
                    :disabled="!valid || loading"
                    :loading="loading"
                    class="v-btn--text success--text"
                    @click="submitHandler"
                  >
                    Submit
                  </v-btn>
                  <v-alert
                    v-model="showError"
                    dismissible
                    icon="mdi-bell"
                    color="error"
                  >
                    ERROR - An error occured processing your PDF, please try
                    again later. If this continues to occur please contact
                    support@mcalpinefree.co.nz
                  </v-alert>
                </v-form>
              </div>
            </v-card-text>
          </base-material-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios'

  // Function to download data to a file
  function download (data, filename, type) {
    var file = new Blob([data], { type: type })
    if (window.navigator.msSaveOrOpenBlob) {
      // IE10+
      window.navigator.msSaveOrOpenBlob(file, filename)
    } else {
      // Others
      var a = document.createElement('a')
      var url = URL.createObjectURL(file)
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      setTimeout(function () {
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      }, 0)
    }
  }

  export default {
    name: 'Uploader',

    data: () => ({
      file: undefined,
      valid: false,
      loading: false,
      showError: false,
      header: '',
      fileRules: [
        value => !!value || 'File is required',
        value =>
          !value ||
          value.size < 1000000 ||
          'File size should be less than 1 MB, uploading larger files will be available soon...',
      ],
    }),

    methods: {
      submitHandler: function (event) {
        if (this.valid) {
          var reader = new FileReader()
          var fileName = this.file.name
          var headerOption = this.header
          this.loading = true

          reader.onload = e => {
            const data = e.target.result.split(',')[1]

            try {
              window.plausible('DemoSubmitPDF')
            } catch (err) {
            /** Ignore analytics error */
            }

            axios
              .post(
                `${process.env.VUE_APP_API_URL}/demo`,
                {
                  template: headerOption,
                  pdf: data,
                },
                {
                  responseType: 'arraybuffer',
                },
              )
              .then(response => {
                this.loading = false
                download(response.data, fileName, 'application/pdf')
              })
              .catch(() => {
                this.loading = false
                this.showError = true
              })
          }
          reader.readAsDataURL(this.file)
        }
      },
    },
  }
</script>
